<template>
  <div
    :style="{ marginTop: '.8rem' }"
    class="c-form-field"
  >
    <div :style="{ color: $colors.grey.base, fontSize: $fontSizes[2] }">
      {{ label }}
    </div>
    <slot />
    <div
      v-if="errorMessage !== ''"
      class="_error-message"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'CFormField',
  props: {
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .c-form-field {
    ._error-message {
      color: map_get($red, 'base');
      font-size: $font-size-4;
    }
  }
</style>
